import React from "react";
import { Container, Grid, Paper, Typography } from "@mui/material";

const TermsAndCondition: React.FC = () => {
  return (
    <>
      <Grid item xs={12} md={12}>
        <Paper elevation={3} style={{ marginBottom: "30px" }}>
          <div
            style={{
              backgroundImage:
                'url("https://eventprix.com/wp-content/uploads/2023/04/Contact-Us-Banner.jpg")',
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
              }}
            ></div>
            <Typography variant="h3" style={{ zIndex: 1, color: "white" }}>
              Terms and Conditions
            </Typography>
          </div>
        </Paper>
      </Grid>

      <Container>
        <div>
          <Typography
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
          >
            <strong style={{ fontSize: "18px", color: "black" }}>
              1. Introduction
            </strong>
            <br />
            EventPrix is a registered entity under EventPrix LLC. By using our
            event ticketing platform (EventPrix), you agree to abide by the
            terms and conditions outlined below. If you do not agree with any
            part of these terms and conditions, please do not use our platform.
          </Typography>

          <Typography
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
            variant="body1"
            marginTop={2}
          >
            <strong style={{ fontSize: "18px", color: "black" }}>
              2. Use of Platform
            </strong>
            <br />
            We or our licensors own all intellectual property rights associated
            with the platform and its content. These rights are reserved and
            protected by law. You may use the platform for personal purposes,
            such as viewing and printing pages, as long as you comply with the
            restrictions outlined in these terms and conditions.
          </Typography>

          <Typography
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
            variant="body1"
            marginTop={2}
          >
            <strong style={{ fontSize: "18px", color: "black" }}>
              3. Proper Conduct
            </strong>
            <br />
            You must not engage in any activity that could harm the Platform or
            interfere with its availability or accessibility. This includes any
            unlawful, illegal, fraudulent, or harmful actions or activities.
          </Typography>
          <Typography
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
            variant="body1"
            marginTop={2}
          >
            <strong style={{ fontSize: "18px", color: "black" }}>
              4. Service Charges
            </strong>
            <br />
            We have three payment options with different fees.
          </Typography>
          <div style={{ paddingLeft: "20px" }}>
            <ul>
              <li
                style={{
                  fontSize: "17px",
                  fontWeight: 400,
                  color: "rgb(122, 122, 122)",
                  fontFamily: "Roboto', sans-serif",
                }}
              >
                Credit card/Debit card: Event attendee/s (one who purchases the
                ticket) will pay $2 per ticket plus credit/debit card processing
                fee and sales tax.*
              </li>
              <li
                style={{
                  fontSize: "17px",
                  fontWeight: 400,
                  color: "rgb(122, 122, 122)",
                  fontFamily: "Roboto', sans-serif",
                }}
              >
                Zelle: Event attendee/s will pay $2 per ticket plus sales tax.*
              </li>
              <li
                style={{
                  fontSize: "17px",
                  fontWeight: 400,
                  color: "rgb(122, 122, 122)",
                  fontFamily: "Roboto', sans-serif",
                }}
              >
                Pay to host: The event host will pay $1 per ticket to EventPrix,
                and the event host will collect sales tax from the attendee/s as
                required.
              </li>
            </ul>
          </div>
          <Typography
            variant="body1"
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
          >
            *EventPrix will pay back $1 from each ticket’s service fee to the
            event host along with ticket sales (applicable for tickets purchased
            through credit/debit card and through Zelle):
          </Typography>
          <Typography
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
            variant="body1"
            marginTop={2}
          >
            <strong style={{ fontSize: "18px", color: "black" }}>
              5. Ticket Sales
            </strong>
            <br />
            Tickets sold through our platform are subject to availability. We
            reserve the right to cancel any ticket purchase at any time.
          </Typography>
          <Typography
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
            variant="body1"
            marginTop={2}
          >
            <strong style={{ fontSize: "18px", color: "black" }}>
              6. Refund Policy
            </strong>
            <br />
          </Typography>
          <Typography variant="body1">
            <span>
              <strong style={{ color: "red" }}>
                All sales are final. No refunds will be issued under any
                circumstances. This includes, but is not limited to:
              </strong>
            </span>
          </Typography>
          <div style={{ paddingLeft: "20px", marginTop: "10px" }}>
            <ul>
              {/* List items */}
              <li
                style={{
                  fontSize: "17px",
                  fontWeight: 400,
                  color: "rgb(122, 122, 122)",
                  fontFamily: "Roboto', sans-serif",
                }}
              >
                Weather conditions, natural disasters, or other events beyond
                the organizer’s control
              </li>
              <li
                style={{
                  fontSize: "17px",
                  fontWeight: 400,
                  color: "rgb(122, 122, 122)",
                  fontFamily: "Roboto', sans-serif",
                }}
              >
                Personal or family emergencies, medical issues, COVID-19
                results, or employment changes
              </li>
              <li
                style={{
                  fontSize: "17px",
                  fontWeight: 400,
                  color: "rgb(122, 122, 122)",
                  fontFamily: "Roboto', sans-serif",
                }}
              >
                Traffic delays, parking difficulties, public or private
                transportation problems, or incorrect directions
              </li>
              <li
                style={{
                  fontSize: "17px",
                  fontWeight: 400,
                  color: "rgb(122, 122, 122)",
                  fontFamily: "Roboto', sans-serif",
                }}
              >
                Purchasing tickets for the wrong date, location, event, or other
                errors
              </li>
              <li
                style={{
                  fontSize: "17px",
                  fontWeight: 400,
                  color: "rgb(122, 122, 122)",
                  fontFamily: "Roboto', sans-serif",
                }}
              >
                Being denied entry or removed from the event by the organizer or
                venue staff for any reason, such as disorderly conduct,
                non-compliance with rules, inappropriate attire, intoxication,
                venue capacity, security breach, etc.
              </li>
            </ul>
          </div>
          <Typography variant="body1" marginTop={2}>
            <strong style={{ color: "red" }}>
              No refunds will be given for any dissatisfaction with the event.
              This includes, but is not limited to:
            </strong>
          </Typography>
          <Typography variant="body1">
            <div style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <ul>
                <li
                  style={{
                    fontSize: "17px",
                    fontWeight: 400,
                    color: "rgb(122, 122, 122)",
                    fontFamily: "Roboto', sans-serif",
                  }}
                >
                  Music, DJ(s), decorations, party favors, beverages, alcohol
                  selection, bar staff, food availability and selection
                </li>
                <li
                  style={{
                    fontSize: "17px",
                    fontWeight: 400,
                    color: "rgb(122, 122, 122)",
                    fontFamily: "Roboto', sans-serif",
                  }}
                >
                  Other attendees, venue staff, event staff, security,
                  performances, ambiance, amenities
                </li>
                <li
                  style={{
                    fontSize: "17px",
                    fontWeight: 400,
                    color: "rgb(122, 122, 122)",
                    fontFamily: "Roboto', sans-serif",
                  }}
                >
                  Venue, check-in process, seating availability and arrangement
                </li>
                <li
                  style={{
                    fontSize: "17px",
                    fontWeight: 400,
                    color: "rgb(122, 122, 122)",
                    fontFamily: "Roboto', sans-serif",
                  }}
                >
                  Wait times in lines or at the bar
                </li>
                <li
                  style={{
                    fontSize: "17px",
                    fontWeight: 400,
                    color: "rgb(122, 122, 122)",
                    fontFamily: "Roboto', sans-serif",
                  }}
                >
                  Emergency closures of event, delayed start or early end of
                  event
                </li>
              </ul>
            </div>
          </Typography>
          <Typography
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
            variant="body1"
            marginTop={2}
          >
            <strong style={{ color: "red" }}>
              By purchasing a ticket, you agree to these terms and conditions.
              EventPrix reserves the right to modify these terms at any time
              without prior notice.
            </strong>
          </Typography>
          <Typography
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
            variant="body1"
            marginTop={2}
          >
            <strong style={{ fontSize: "18px", color: "black" }}>
              7.a ChargeBacks & Recovery – Card Owner
            </strong>
            <br />
            By purchasing a ticket from EventPrix, the card owner agrees to the
            terms and conditions stated above. If the card owner initiates a
            chargeBack or dispute with their bank in violation of these terms,
            EventPrix will charge the card owner a dispute fee and the disputed
            amount. The card owner must pay this amount to EventPrix through
            Zelle/ACH within 7 days of receiving an email invoice. Otherwise,
            EventPrix will refer the case to a Debt Collection agency.
          </Typography>
          <Typography
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
            variant="body1"
            marginTop={2}
          >
            <strong style={{ fontSize: "18px", color: "black" }}>
              7.b ChargeBacks & Recovery – Event Organizer
            </strong>
            <br />
            When a card owner disputes a charge from EventPrix, EventPrix will
            provide the necessary evidence to its payment processor to contest
            the dispute. However, EventPrix will also deduct the disputed amount
            and the dispute fee from the event organizer’s balance. If the event
            organizer’s balance is zero or negative, EventPrix will keep a
            record of the outstanding amount in the event organizer’s account.
            The event organizer must pay this amount to EventPrix within four
            months of receiving the chargeBack notification. If the event
            organizer fails to do so, EventPrix will refer the case to a Debt
            Collection agency.
          </Typography>
          <Typography
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
            variant="body1"
            marginTop={2}
          >
            <strong style={{ fontSize: "18px", color: "black" }}>
              8. Liability Limitations
            </strong>
            <br />
            EventPrix does not own any liability for death or personal injury
            resulting from negligence, fraud or fraudulent misrepresentation, or
            any other liability that cannot be limited or excluded by law.
          </Typography>
          <Typography
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
            variant="body1"
            marginTop={2}
          >
            <strong style={{ fontSize: "18px", color: "black" }}>
              9. Indemnification
            </strong>
            <br />
            You agree to indemnify us against any losses, damages, costs,
            liabilities, and expenses that we may incur as a result of your
            breach of these terms and conditions.
          </Typography>
          <Typography
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
            variant="body1"
            marginTop={2}
          >
            <strong style={{ fontSize: "18px", color: "black" }}>
              10. Enforcement
            </strong>
            <br />
            If you breach these terms and conditions, we may take appropriate
            action to address the breach. This may include suspending your
            access to the platform, prohibiting you from accessing the platform,
            blocking your IP address from accessing the platform, contacting
            your internet service provider to request that they block your
            access to the platform, and/or taking legal action against you.
          </Typography>
          <Typography
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
            }}
            variant="body1"
            marginTop={2}
          >
            <strong style={{ fontSize: "18px", color: "black" }}>
              11. Changes to Terms and Conditions
            </strong>
            <br />
            We may update these terms and conditions from time to time. The
            updated terms and conditions will apply to your use of the platform
            from the date they are published on the platform.
          </Typography>
          <Typography
            variant="body1"
            marginTop={2}
            style={{
              fontSize: "17px",
              fontWeight: 400,
              color: "rgb(122, 122, 122)",
              fontFamily: "Roboto', sans-serif",
              paddingBottom: "30px",
            }}
          >
            <strong style={{ fontSize: "18px", color: "black" }}>
              12. Governing Law
            </strong>
            <br />
            These terms and conditions are governed by US governing law and any
            disputes related to these terms and conditions will be subject to
            the exclusive jurisdiction of the courts of Texas (U.S.A.)
          </Typography>
        </div>
      </Container>
    </>
  );
};

export default TermsAndCondition;
